import React from 'react';
import { Check, Circle } from 'lucide-react';
import { validatePassword } from '../utils/passwordValidation';

interface PasswordRequirementsProps {
  password: string;
}

export const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ password }) => {
  if (!password) return null;

  const requirements = validatePassword(password);

  return (
    <ul className="mt-2 space-y-1">
      {requirements.map((req) => (
        <li key={req.key} className="flex items-center gap-1.5 text-xs">
          {req.met ? (
            <Check className="h-3.5 w-3.5 text-green-500 flex-shrink-0" />
          ) : (
            <Circle className="h-3.5 w-3.5 text-gray-300 flex-shrink-0" />
          )}
          <span className={req.met ? 'text-green-600' : 'text-gray-500'}>
            {req.label}
          </span>
        </li>
      ))}
    </ul>
  );
};
